import { useEffect } from "react";
/**
 * This hook will apply the current mode class name to the `document.body` so
 * that the specific mode style mixins work as expected.
 *
 * @private
 */
export default function useModeClassName(mode) {
    useEffect(function () {
        var className = "rmd-utils--" + mode;
        document.body.classList.add(className);
        return function () {
            document.body.classList.remove(className);
        };
    }, [mode]);
}
//# sourceMappingURL=useModeClassName.js.map